import axios from "axios";
import { servicePath } from "../../utility/data";


export const addAsset = async (assetData, assetTypeName, accessToken) => {

  const payload = {
    "name": assetData.name,
    "sector": assetData.sector,
    "included_in": assetData.inclusion.id,
    "currency": assetData.currency,
    "initial_balance": assetData.initialBalance ? assetData.initialBalance : 0,
    // "balance": assetData.balance,
    // "status": assetData.status,
    "asset_type": assetData.assetType,
    "asset_type_id": assetData.assetTypeId,
    "date": assetData.date,
    "commitment": assetData.commitment ? assetData.commitment : 0,
    "isin": assetData.isin ? assetData.isin : null,
    "quantity": assetData.quantity ? assetData.quantity : 0,
    "cost_price": assetData.costPrice ? assetData.costPrice : 0,
    "linked_with": null,
    "noi": assetData.noi ? assetData.noi : 0,
    "cap_rate": assetData.capRate ? assetData.capRate : 0,
    "legacy": assetData.legacy ? assetData.legacy : null,
    "ownership": assetData.ownership ? assetData.ownership : 0,
    "ebitda": assetData.ebitda ? assetData.ebitda : 0,
    "multiples": assetData.multiples ? assetData.multiples : 0,
    "ownership_type": assetData.ownershipType ? assetData.ownershipType : null,
    "company_asset_type": assetData.companyAssetType ? assetData.companyAssetType : null,
    "symbol": assetData.symbol ? assetData.symbol.symbol : null,
    "cash_asset_id": assetData?.cashAssets?.id || null,
  };

  try {
    const response = await axios.post(`${servicePath}/asset/add-asset`, payload, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
    });

    return response;
  } catch (error) {
    console.error('Error :', error);
    throw new Error(error.response ? error.response.data.message : 'not submit');
  }
};



export const getSymbolServices = async (searchTerms, accessToken) => {

  try {
    const response = await axios.get(`${servicePath}/stock/isin-symbol?query=${searchTerms}`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
    });

    return response;
  } catch (error) {
    console.error('Error:', error);
    throw new Error(error.response ? error.response.data.message : 'error to getting data');
  }
};